var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg44Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 17,
    viewBox: "0 0 169 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1354_4961)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7803,
    height: 14.7803,
    rx: 7.39014,
    transform: "matrix(1 0 0 -1 1 15)",
    fill: "#73C7A9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.7803,
    height: 14.7803,
    rx: 7.39014,
    transform: "matrix(1 0 0 -1 102.351 15)",
    fill: "#73C7A9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.7803,
    height: 14.7803,
    rx: 7.39014,
    transform: "matrix(1 0 0 -1 52.1802 15)",
    fill: "#73C7A9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.7803,
    height: 14.7803,
    rx: 7.39014,
    transform: "matrix(1 0 0 -1 153.026 15)",
    fill: "#73C7A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1354_4961",
    x: 0,
    y: 0.219727,
    width: 168.806,
    height: 16.7803,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1354_4961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1354_4961",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg44Svg);
export default __webpack_public_path__ + "static/media/4-4.svg.0151ced155ff52a242692e2c532313bc.svg";
export { ForwardRef as ReactComponent };